<canvas id="canvas1" #mainCanvas></canvas>